import { useId } from "react";

import { Field, errorInputStyle, inputStyle } from "./Field";

interface NumberFieldProps {
  label: string;
  value: number | null;
  onChange: (value: number | null) => void;
  required?: boolean;
  placeholder?: string;
  helper?: React.ReactNode;
  error?: string | null;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
}

export function NumberField({
  label,
  value,
  onChange,
  required,
  placeholder,
  helper,
  error,
  min,
  max,
  step,
  disabled,
}: NumberFieldProps) {
  const id = useId();
  return (
    <Field label={label} htmlFor={id} required={required} helper={helper} error={error}>
      <input
        id={id}
        type="number"
        value={value ?? ""}
        onChange={(e) => {
          const raw = e.target.value;
          onChange(raw === "" ? null : Number(raw));
        }}
        required={required}
        placeholder={placeholder}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        style={error ? errorInputStyle : inputStyle}
      />
    </Field>
  );
}
